module.exports = __webpack_public_path__ + "img/13.9a99c391.png";